import * as types from "../../../_constants/types";

export default (state = [], action) => {
    switch (action.type) {
        case types.LANGUAGE_LIST_LOAD:
            return [...action.data];

        case types.RESET:
        case types.LANGUAGE_LIST_RESET:
            return [];

        default:
            return state;
    }
};
